import { cva, type VariantProps } from 'class-variance-authority';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes with proper conflict resolution.
 * Combines clsx for conditional classes and tailwind-merge for deduplication.
 *
 * @example
 * classNames('px-2 py-1', isActive && 'bg-blue-500', className)
 */
export function classNames(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const cn = classNames;

/**
 * Re-export cva for convenient use throughout the project.
 * Use cva to create type-safe component variants.
 *
 * @example
 * const buttonVariants = cva('base-class', {
 *   variants: {
 *     variant: { primary: 'bg-blue-500', secondary: 'bg-gray-500' }
 *   }
 * });
 */
export { cva };

/**
 * Type helper to extract variant props from a cva variant definition.
 * Useful for creating component prop types that include variant props.
 *
 * @example
 * const buttonVariants = cva('base-class', { variants: { ... } });
 * type ButtonVariants = VariantProps<typeof buttonVariants>;
 */
export type { VariantProps };
